(function () {
  'use strict';

  var desktopMedia = window.matchMedia('(min-width: 750px)');

  function setActiveGroup(menu, group) {
    var groups = menu.querySelectorAll('.site-nav__articles-group');
    for (var index = 0; index < groups.length; index += 1) {
      var isActive = groups[index] === group;
      groups[index].classList.toggle('site-nav__articles-group--active', isActive);

      var parentLink = groups[index].querySelector(':scope > .site-nav__child-link--parent');
      if (parentLink && groups[index].querySelector(':scope > .site-nav__articles-panel')) {
        parentLink.setAttribute('aria-expanded', isActive ? 'true' : 'false');
      }
    }
  }

  function initMenu(menu) {
    if (menu.getAttribute('data-fa-articles-menu-ready') === 'true') return;
    menu.setAttribute('data-fa-articles-menu-ready', 'true');

    var groups = menu.querySelectorAll('.site-nav__articles-group');
    var initialGroup = null;

    for (var index = 0; index < groups.length; index += 1) {
      var group = groups[index];
      var panel = group.querySelector(':scope > .site-nav__articles-panel');
      var parentLink = group.querySelector(':scope > .site-nav__child-link--parent');

      if (!panel || !parentLink) continue;
      if (!initialGroup) initialGroup = group;

      parentLink.setAttribute('aria-expanded', 'false');
      group.addEventListener('mouseenter', function () {
        setActiveGroup(menu, this);
      });
      parentLink.addEventListener('focus', function () {
        setActiveGroup(menu, this.parentElement);
      });
    }

    if (initialGroup) setActiveGroup(menu, initialGroup);
  }

  function start() {
    if (!desktopMedia.matches) return;

    var menus = document.querySelectorAll('.site-nav--articles-menu');
    for (var index = 0; index < menus.length; index += 1) initMenu(menus[index]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  desktopMedia.addEventListener('change', start);
})();
